import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from '../../../../core/data/data-service';
import { CommonService } from '../../../../common/services/common.service';
import { AttractorLoopService } from '../../../../core/routing/services/asset-library/attractor-loop.service';
import { GlobalConstants } from './../../../../common/constants/global.constant';
import { AssetLibraryConstants } from '../../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../../environments/environment';
import { HeroTileService } from '../../../../core/routing/services/asset-library/hero-tile.service';
import { HeroTile, SelectedHeroTileForProfile, SingleTileData, HeroTilePreview } from './interfaces/hero-tile.i';
import { Observable } from 'rxjs';
import { CreateProfileService } from '../../../../core/routing/services/profile/create-profile.service';
import { ProfileStoreService } from '../../../../modules/create-profile/store/profile.store';
import { ProfileRequest, HeroTile as ProfileHeroTile, ProfileUpdateResponse, CustomHeroTile } from '../../../create-profile/interface/profile.i';
import { RouterConstants } from '../../../../core/routing/constants/app-paths.constant';
import { Utils } from './../../../../common/utils/utils';
import { map } from 'rxjs/operators';
import { LanguageConstants } from '../../../../modules/header/constants/lang.consts';
import { SendToStoreService } from '../../../../core/routing/services/asset-library/send-to-store.service';

@Component({
  selector: 'iposcen-hero-tile',
  templateUrl: './hero-tile.component.html',
  styleUrls: ['./hero-tile.component.scss']
})
export class HeroTileComponent implements OnInit, OnDestroy {
  @ViewChild('deleteModal') deleteModal: ElementRef;
  @ViewChild('sendToRetailerModal') sendToRetailerModal: ElementRef;
  @ViewChild('sendToAccountModal') sendToAccountModal: ElementRef;
  @Output() readonly sendHeroLength = new EventEmitter();
  @Output() readonly sendHeroTileData = new EventEmitter();
  @Input() isDeviceMainTile = false;
  @Input() idFromMainContent;
  @Input() isNoneChecked;
  sendEditData;
  isDuplicateEnabled: any;
  newCustomTileResponse: any;
  isAllAssetUploaded = {
    page1: false,
    page2: false,
    page3: false,
    main: false,
    gamingBanner: false
  };
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  intelAdmin = GlobalConstants.INTEL_ADMIN;
  retailHQUser = GlobalConstants.RETAIL_HQ_USER;
  regionalHQ = GlobalConstants.REGIONALHQ;
  storeUser = GlobalConstants.STORE_USER;
  displayHeroTiles = [];
  allHeroTile: HeroTile[];
  tabIndex = 0;
  previewTabIndex = 0;
  globalconst = GlobalConstants;
  pageType: string = GlobalConstants.HERO_TILE;
  currentdetailPage: string;
  presentPage: string;
  profilePage: string = GlobalConstants.PROFILE;
  assetsPage: string = GlobalConstants.ASSET_LIBRARY;
  sortValue = GlobalConstants.CREATED_DATE;
  page = 1;
  pageSize = 5;
  maxSize = 5;
  herTileoToDelete: string;
  heroTileToDeleteName: string;
  heroTileToShare: string;
  heroTileToShareName: string;
  heroTileToShareDesc: string;
  heroTileSuccessMsg: string;
  heroTileSuccessInfoMsg: string;
  isSuccess: boolean;
  attractorLoopData: object;
  pageGrpForm: any;
  mediaObjects: any[] = [];
  heroTilePreviewData: HeroTilePreview;
  singleTileData: SingleTileData;
  profileData: ProfileUpdateResponse;
  operatingSystem: string;
  windows: string = GlobalConstants.WINDOWS_OS;
  windows10S: string = GlobalConstants.WINDOWS_UWP;
  mainTileAssetText: string = GlobalConstants.MAIN_TILE_ASSET_TXT;
  internalName = GlobalConstants.INTERNAL_NAME;
  linux: string = GlobalConstants.LINUX_OS;
  isCustomTileEnabled = false;
  isSrtEnabled = false;
  isCustomTabActive = true;
  enableActiveTab = false;
  createNewCustomTile = false;
  isCustomContentTabActive = true;
  isSrtTabActive = false;
  changePlacement: boolean;
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  isSendToStore = false;
  isRegionalHQ = false;
  isRetailerUser = false;
  isStoreUser = false;
  sendButtonText: string;
  HeroTileIdInfo: string;
  sendNameToStore: string;
  displayBannerContentGroups = [];
  optionalButton: string = GlobalConstants.OPTIONAL_TOOLTIP;
  selectedHeroTileForProfile: SelectedHeroTileForProfile = {
    contentGrps: [],
    showOnDevice: false
  };
  profileDataSet: ProfileRequest;
  profileHeroTileContentData: ProfileHeroTile[];
  profileCustomHeroTileData: CustomHeroTile[];
  selctedContGrpsForProfile: SelectedHeroTileForProfile = {
    contentGrps: [],
    showOnDevice: false
  };
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  getSrtHeroTileImagesUrl = environment.apiBaseUrlAsset + this.url + AssetLibraryConstants.SRT_HERO_TILES + AssetLibraryConstants.SLASH;
  sendctavalue: string;
  deleteTooltipLabel = GlobalConstants.DELETE;
  editTooltipLabel = GlobalConstants.EDIT;
  sendToStoresTooltipLabel: string = GlobalConstants.OPTIONAL_TOOLTIP;
  createdDateVal = GlobalConstants.CREATED_DATE;
  groupNameVal = GlobalConstants.GROUP_NAME;
  profileDetails
  chrome: string = GlobalConstants.CHROME_TYPE;
  getSrtCustomTile: any;
  tabActive = GlobalConstants.CUSTOM_CONTENT;
  enableCustomSrt = false;
  showDevice = false;
  showonDeviceDisabled = GlobalConstants.SHOW_ON_DEVICE_DISABLED;
  addToPackageDisabled = GlobalConstants.ADD_TO_PACKAGE_DISABLED;
  profileNameValue = GlobalConstants.PROFILE_NAME_LOWER_CASE;
  clickedRight: boolean = false;
  isCustomNone: boolean;
  isRussian = localStorage.getItem('preferredLanguage') === 'ru';
  isGreek = localStorage.getItem('preferredLanguage') === 'el';
  isPolish = localStorage.getItem('preferredLanguage') === 'pl';
  isFrench = localStorage.getItem('preferredLanguage') === 'fr';
  isSpanish = localStorage.getItem('preferredLanguage') === 'es';
  isPortugese = localStorage.getItem('preferredLanguage') === 'pt';
  isItalian = localStorage.getItem('preferredLanguage') === 'it'
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private router: Router,
    private cmnService: CommonService,
    private dataService: DataService,
    private attractorLoopService: AttractorLoopService,
    private heroTileService: HeroTileService,
    private createProfileService: CreateProfileService,
    private profileStoreService: ProfileStoreService,
    private sendToStoreService: SendToStoreService

  ) { }

  ngOnInit(): void {
    this.HeroTileIdInfo = '';
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
    this.isRetailerUser = (this.retailHQUser === 'retailHQUser');
    this.isRegionalHQ = (this.retailHQUser === 'regionalHQ');
    this.isStoreUser = (sessionStorage.getItem(GlobalConstants.USER_ROLE) === GlobalConstants.STORE_USER);
    this.heroTilePreviewData = {
      image: {
        name: '',
        url: '',
        format: ''
      },
      button: {
        value: ''
      }
    };
    if (this.isDeviceMainTile) {
      this.getAllHeroTilesByUser(GlobalConstants.CUSTOM_CONTENT);
    }
    else {
      this.setHeroTileContentForAssetLibrary();
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setHeroTileContentForAssetLibrary() {
    this.cmnService.setToSrtTab(false);
    this.cmnService.getToSrtTab.subscribe(data => {
      if (data) {
        this.tabChange('srt-content');
      }
    });
    if (this.profileStoreService.currentWorkingProfile) {
      this.profileDataSet = JSON.parse(JSON.stringify(this.profileStoreService.currentWorkingProfile));
    }
    this.currentdetailPage = this.router.url;
    const pageName = this.currentdetailPage.lastIndexOf('/');
    if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.ASSET_LIBRARY) {
      this.presentPage = GlobalConstants.ASSET_LIBRARY;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE ||
      this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE)) {
      this.presentPage = GlobalConstants.PROFILE;
    }
    if (this.presentPage === GlobalConstants.PROFILE) {
      const data = this.createProfileService.getProfileId();
      this.profileData = this.profileStoreService?.currentWorkingProfile;
      const settings = JSON.parse(this.profileData?.settings);
      this.operatingSystem = settings?.otherSettings?.operatingSystem;
    }
    this.isSuccess = false;
    this.cmnService.getCustomTileEnabled.subscribe(res => {
      if (res) {
        this.isCustomTileEnabled = true;
      }
    });
    this.cmnService.getSrtTileEnabled.subscribe(res => {
      if (res) {
        this.isSrtEnabled = true;
      }
    });
    if (this.isSrtEnabled && this.isCustomTileEnabled) {
      this.getAllHeroTilesByUser(GlobalConstants.CUSTOM_CONTENT);
      this.tabActive = GlobalConstants.CUSTOM_CONTENT;
      this.enableCustomSrt = true;
      this.pageType = GlobalConstants.CUSTOM_AND_HERO;
    } else if (this.isSrtEnabled || this.userRole === this.intelAdmin) {
      this.getAllHeroTilesByUser(GlobalConstants.SRT_CONTENT);
      this.tabActive = GlobalConstants.SRT_CONTENT
      this.pageType = GlobalConstants.HERO_TILE;
    } else {
      this.tabActive = GlobalConstants.CUSTOM_CONTENT;
      this.getAllHeroTilesByUser(GlobalConstants.CUSTOM_CONTENT);
      this.pageType = GlobalConstants.CUSTOM_TILE;
    }
    this.cmnService.setHeroTab(this.tabActive);
    // this.cmnService.emitRefreshHeroTileDataObser
    //   .pipe(takeUntil(this.ngUnsubscribe))
    //   .subscribe((data) => {
    //     this.getAllHeroTilesByUser(GlobalConstants.SRT_CONTENT);
    //   });
    this.createProfileService.getUpdatedProfileById(this.createProfileService.getProfileId())
      .subscribe(res => {
        if (res.profile.srtHeroTiles || res.profile.customHeroTiles) {
          if (GlobalConstants.SRT_CONTENT === this.tabActive) {
            this.profileDetails = (res.profile.srtHeroTiles !== undefined) ? res.profile.srtHeroTiles[0] : [];
          } else {
            this.profileDetails = (res.profile.customHeroTiles !== undefined) ? res.profile.customHeroTiles[0] : [];
          }
          if (!this.profileDetails.showOnDevice) {
            this.cmnService.emitLivePreviewImageData('');
            this.cmnService.emitLivePreviewCTAData('');
          }
        } else {
          this.cmnService.emitLivePreviewImageData('');
          this.cmnService.emitLivePreviewCTAData('');
        }
      });
  }

  getAllHeroTilesByUser(data) {
    this.displayHeroTiles = [];
    if (data === GlobalConstants.SRT_CONTENT && this.operatingSystem !== this.linux) {
      this.getSrtCustomTile = this.heroTileService.getAllHeroTileByUser();
    } else if (data === GlobalConstants.CUSTOM_CONTENT) {
      this.getSrtCustomTile = this.heroTileService.getAllCustomHeroTileByUser();
    } else {
      this.getSrtCustomTile = undefined; // adding getSrtCustomTile value to undefined to stop api call.
    }
    if (this.getSrtCustomTile !== undefined) {
      this.getSrtCustomTile.pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(getAllHeroTiles => {
          this.allHeroTile = (getAllHeroTiles.srtHeroTile as HeroTile[]);
          this.isCustomNone = (this.isDeviceMainTile) ? false : true;
          if (data === GlobalConstants.CUSTOM_CONTENT) {
            this.allHeroTile = (getAllHeroTiles.customHeroTile as HeroTile[]);
            this.sendHeroLength.emit(this.allHeroTile.length);
            if (this.isDeviceMainTile) {
              this.allHeroTile.forEach(ele => {
                if (ele.id === this.idFromMainContent && this.idFromMainContent !== undefined) {
                  ele.showOnDevice = true;
                }
                else if (this.isNoneChecked) {
                  this.isCustomNone = true;
                }
              })
            }
          }
          this.allHeroTile.forEach(ele => {
            const heroTileConfigurationData = JSON.parse(ele.configurations);
            const createdDate = (ele.createdByUser === this.userId) ? GlobalConstants.ME : GlobalConstants.INTEL_ADMIN_CREATED;
            try {
              ele.configurations = JSON.parse(ele.configurations);
            }
            catch (err) {
              console.log(err);
            }
            if (data === GlobalConstants.CUSTOM_CONTENT) {
              ele.createdByUser = createdDate;
              ele.heroImageURL = `${environment.apiBaseUrlAsset}${this.url}${AssetLibraryConstants.SRT_HERO_TILES}${AssetLibraryConstants.SLASH}${ele.id}${AssetLibraryConstants.SLASH}${AssetLibraryConstants.MAIN_TILE_IMAGE}`;
              ele.gamingImageURL = `${environment.apiBaseUrlAsset}${this.url}${AssetLibraryConstants.SRT_HERO_TILES}${AssetLibraryConstants.SLASH}${ele.id}${AssetLibraryConstants.SLASH}${AssetLibraryConstants.GAMING_IPOS_BANNER}`;
              ele.heroImageFile = heroTileConfigurationData?.imageFile;
              ele.gamingImageFile = heroTileConfigurationData?.gamingImageFile;
              // ele.fallbackExeFile = heroTileConfigurationData?.fallbackExeFile;
              ele.formFactor = Utils.getFormFactorNames(heroTileConfigurationData?.formFactor);
            } else {
              ele.createdByUser = createdDate;
              ele.heroImageURL = `${this.getSrtHeroTileImagesUrl}${ele.id}${AssetLibraryConstants.HERO_TILE_PATH}`;
              ele.gamingImageURL = `${this.getSrtHeroTileImagesUrl}${ele.id}${AssetLibraryConstants.GAMING_BANNER_PATH}`;
              ele.heroImageFile = heroTileConfigurationData?.heroImageFile;
              ele.gamingImageFile = heroTileConfigurationData?.gamingImageFile;
              ele.fallbackExeFile = heroTileConfigurationData?.fallbackExeFile;
            }
            this.displayHeroTiles.push(ele);
          });
          this.displayHeroTiles.forEach(element => {
            element.isExpanded = false;
            element.previewTabIndex = 0;
            if (element.updateTime) {
              element.updateTime = new Date(element.updateTime);
            }
            if (element.sentTime) {
              element.sentTime = new Date(element.sentTime);
            }
            if (element.sentTime !== undefined) {
              element.isEditAfterSent = element.updateTime > element.sentTime;
            } else {
              element.isEditAfterSent = false;
            }

            // converting date format:
            if (element && element?.configurations) {
              if (element?.configurations?.publishTime && !element?.configurations?.isPublishDateNow) {
                //changing it to old format
                element.configurations.publishTime = Utils.ChangetoOldFormat(element?.configurations?.publishTime);
              }
              if (element?.configurations?.expireTime && element?.configurations?.expireTime !== GlobalConstants.NEVER) {
                //changing it to old format
                element.configurations.expireTime = Utils.ChangetoOldFormat(element?.configurations?.expireTime);
              }
              if (element?.configurations?.expireTime && element?.configurations?.expireTime === GlobalConstants.NEVER) {
                element.configurations.expireTime = LanguageConstants.NEVER;
              }
            }
            if ((this.presentPage === GlobalConstants.PROFILE)) {
              element.showOnDevice = false;
              element.addToPackage = false;
            }
            // For content expired notification
            element.isContentExpires = Utils.getExpiredContentdata(element);
          });
          this.sortByDate();
          //IIT2-6238 STARTS
          if (this.presentPage === GlobalConstants.PROFILE) {
            this.displayHeroTiles.forEach(a => a.showOnDevice = a.addToPackage = false);
            this.selctedContGrpsForProfile = {
              contentGrps: []
            };
            this.prefillProfileData();
            this.displayHeroTiles.forEach((element, index) => {
              element.index = index;
              if (this.isCustomNone) {
                this.isCustomNone = !element.showOnDevice;
              }
            });
            // If clicks on  showOnDevice Popup
            if (this.showDevice) {
              let custCont = this.displayHeroTiles
                .filter(a => a.addToPackage === true)
                .sort((a, b) => new Date(a.updateTime).getTime() - new Date(b.updateTime).getTime());
              if (this.selctedContGrpsForProfile?.contentGrps?.length === GlobalConstants.PRICE_CONTENT_GRP_MAX_IN_PACKAGE) {
                this.setCustomPackageNshowOnDeviceVal(custCont[0].index, false);//if limit reached. set values to false since we are de-selecting
              }
              if (this.selctedContGrpsForProfile?.showOnDevice) {
                this.findIndexAndSetValue(GlobalConstants.DISPLAY_CUSTOM_TILE, GlobalConstants.ID, false);//de-select in display custom-tile content
                this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.CUSTOM_HERO_TILE_ID, false);//de-select in selectedCntGrps
              }
              if (this.selctedContGrpsForProfile?.contentGrps?.length === GlobalConstants.PRICE_CONTENT_GRP_MAX_IN_PACKAGE) {
                //Since maximum limit reached remove the earliest created one
                this.selctedContGrpsForProfile.contentGrps = this.selctedContGrpsForProfile.contentGrps
                  .filter(a => a.customHeroTileId !== custCont[0].id);
              }
              this.displayHeroTiles[0].addToPackage = true;// add to package/showondevice since selected yes on pop-up
              this.displayHeroTiles[0].showOnDevice = true;
              this.pushToSelectedGrps(0);
              this.selctedContGrpsForProfile.showOnDevice = this.displayHeroTiles[0].id;
              //update back to profile/ and profile store
              this.createProfileService.updateProfile(
                this.profileDataSet?.profileId, { priceContents: this.selctedContGrpsForProfile.contentGrps }
              )
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(data => {
                  const profileUpdateResponse = data.profile as ProfileUpdateResponse;
                  this.profileStoreService.updateProfileData(profileUpdateResponse);
                });
              //IIT2-6238 ENDS
            }
          }

        },
          error => {
            this.displayHeroTiles = [];
          });
    }
  }


  prefillProfileData() {
    const existingProfileData = JSON.parse(JSON.stringify(this.profileStoreService.currentWorkingProfile));
    if (existingProfileData && (existingProfileData?.profileId === this.createProfileService.getProfileId())) {
      this.profileDataSet = existingProfileData as ProfileRequest;
      let content
      if (GlobalConstants.SRT_CONTENT === this.tabActive) {
        this.profileHeroTileContentData = this.profileDataSet.srtHeroTiles;
        content = this.profileHeroTileContentData;
      } else if (GlobalConstants.CUSTOM_CONTENT === this.tabActive) {
        this.profileCustomHeroTileData = this.profileDataSet.customHeroTiles;
        content = this.profileCustomHeroTileData;
      }

      if (content?.length) {
        this.selctedContGrpsForProfile = {
          contentGrps: []
        };
        this.displayHeroTiles.forEach(a => a.showOnDevice = false);
        let isSrtContentNone = (this.profileHeroTileContentData?.length == 1 && !this.profileHeroTileContentData[0].showOnDevice && this.profileHeroTileContentData[0].srtHeroTileId === undefined);
        let isMainTileContentNone = (this.profileCustomHeroTileData?.length == 1 && !this.profileCustomHeroTileData[0].showOnDevice && this.profileCustomHeroTileData[0].customHeroTileId === undefined);
        if (isSrtContentNone || isMainTileContentNone) this.selctedContGrpsForProfile.contentGrps = [];
        else this.selctedContGrpsForProfile.contentGrps = content;
        this.selctedContGrpsForProfile.contentGrps.forEach((ele) => {
          let contentIdInd
          if (GlobalConstants.SRT_CONTENT === this.tabActive) {
            contentIdInd = this.displayHeroTiles.findIndex(each => each.id === ele.srtHeroTileId);

          } else if (GlobalConstants.CUSTOM_CONTENT === this.tabActive) {
            contentIdInd = this.displayHeroTiles.findIndex(each => each.id === ele.customHeroTileId);
          }
          if (contentIdInd >= 0) {
            this.displayHeroTiles[contentIdInd].addToPackage = true;
            this.displayHeroTiles[contentIdInd].showOnDevice = ele.showOnDevice;
            if (ele.showOnDevice) {
              this.selctedContGrpsForProfile.showOnDevice = this.displayHeroTiles[contentIdInd].id;
            }
            this.heroTilePreviewData.image.url = this.displayHeroTiles[contentIdInd].heroImageURL;
            this.heroTilePreviewData.button.value = this.displayHeroTiles[contentIdInd].callToAction;
            this.cmnService.emitDataToLivePreview({ page: GlobalConstants.HERO_TILE, dataSet: this.heroTilePreviewData });
          }
        });
      }
    }
  }

  cancel() {
    this.dataService.setAttractorLoop(undefined);
    this.setIndex(0);
  }

  openSendHeroTileData(heroTileID: string) {
    this.sendButtonText = GlobalConstants.HERO_BUTTON_TEXT;
    this.HeroTileIdInfo = heroTileID;
    this.sendNameToStore = this.displayHeroTiles.find(ele => ele.id === heroTileID).configurations.publishedName;
    this.openModal(this.sendToAccountModal);
  }
  getSelectedStoreData(data) {
    this.sendToStoreService.sendHeroTileToStoreService(this.HeroTileIdInfo, data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(sendToStoreResponse => {
        if (sendToStoreResponse['response-context'].statusCode === GlobalConstants.SUCCESS_RESPONSE_CODE) {
          this.isSendToStore = true;
        }
      });
  }

  editheroTile(heroTileID: string, which?, data?) {
    if (which === GlobalConstants.SRT_CONTENT) {
      const heroTileToEdit = this.displayHeroTiles.find(ele => ele.id === heroTileID);
      this.dataService.setHeroTile(heroTileToEdit);
      this.setIndex(1);
    } else if (which === GlobalConstants.CUSTOM_CONTENT) {
      this.tabIndex = 3;
      this.sendEditData = data;
    }
  }
  editCustomTile(id, data) {
    this.tabIndex = 3;
    this.sendEditData = data;
  }
  duplicateCustomTile(data) {
    this.isDuplicateEnabled = data;
    let formFactors = Utils.getFormFactorValues(data.formFactor);
    let payload = {
      publishedName: `copy of ${data.configurations.publishedName}`,
      internalName: data.configurations.internalName,
      callToAction: data.callToAction,
      createdByUser: sessionStorage.getItem('email'),
      configurations: JSON.stringify({
        publishedName: `copy of ${data.configurations.publishedName}`,
        internalName: data.configurations.internalName,
        publishTime: data?.configurations?.publishTime,
        expireTime: data?.configurations?.expireTime,
        type: AssetLibraryConstants.CUSTOM_TILE_GROUP,
        imageFile: data.configurations.imageFile,
        gamingImageFile: data.configurations.gamingImageFile,
        formFactor: formFactors,
        customURL: data.configurations.customURL,
        isPublishDateNow: data?.configurations?.isPublishDateNow,
        isPublishExpiryNever: data?.configurations?.isPublishExpiryNever,
        contentGroupPages: data.configurations.contentGroupPages,
        bgColor: data?.configurations?.bgColor ? data?.configurations?.bgColor : '#000000',
        gamingBgColor: data?.configurations?.gamingBgColor ? data?.configurations?.gamingBgColor : '#000000'
      })
    }
    this.heroTileService.createCustomTile(payload)
      .pipe(map(res => res.customHeroTile))
      .subscribe(res => {
        res.configurations = JSON.parse(res.configurations);
        this.newCustomTileResponse = res;
        this.uploadImage(this.newCustomTileResponse.id, this.isDuplicateEnabled.id);
      })
  }
  uploadImage(newId, oldId) {
    this.heroTileService.getUploadImage(oldId, AssetLibraryConstants.MAIN_TILE_IMAGE, false)
      .subscribe(image => {
        this.heroTileService.uploadImage(image, newId, AssetLibraryConstants.MAIN_TILE_IMAGE, 'image')
          .subscribe(res => {
            this.isAllAssetUploaded.main = true;
            this.checkIfAllAssetAreUploaded();
          });
      })
    this.heroTileService.getUploadImage(oldId, AssetLibraryConstants.GAMING_IPOS_BANNER, false)
      .subscribe(image => {
        this.heroTileService.uploadImage(image, newId, AssetLibraryConstants.GAMING_IPOS_BANNER, 'image')
          .subscribe(res => {
            this.isAllAssetUploaded.gamingBanner = true;
            this.checkIfAllAssetAreUploaded();
          });
      })
    if (this.isDuplicateEnabled.configurations.contentGroupPages.length) {
      if (this.isDuplicateEnabled.configurations.contentGroupPages.length === 1) {
        this.isAllAssetUploaded.page2 = true;
        this.isAllAssetUploaded.page3 = true;
      } else if (this.isDuplicateEnabled.configurations.contentGroupPages.length === 2) {
        this.isAllAssetUploaded.page3 = true;
      }
      this.isDuplicateEnabled.configurations.contentGroupPages.forEach((data) => {
        if (!!data.fileName) {
          this.heroTileService.getUploadImage(oldId, data.pageNum, true)
            .subscribe(image => {
              this.heroTileService.putS3CustomTileContentByPageId(image, data.fileName.split('.').pop(), newId, data.pageNum)
                .subscribe(_ => {
                  this.isAllAssetUploaded["page" + data.pageNum] = true;
                  this.checkIfAllAssetAreUploaded();
                });

            })
        } else {
          this.isAllAssetUploaded["page" + data.pageNum] = true;
          this.checkIfAllAssetAreUploaded();
        }

      })
    } else {
      this.isAllAssetUploaded.page1 = true;
      this.isAllAssetUploaded.page2 = true;
      this.isAllAssetUploaded.page3 = true;
      this.checkIfAllAssetAreUploaded();
    }
  }
  checkIfAllAssetAreUploaded() {
    if (this.isAllAssetUploaded.main && this.isAllAssetUploaded.gamingBanner && this.isAllAssetUploaded.page1 && this.isAllAssetUploaded.page2 && this.isAllAssetUploaded.page3) {
      this.editCustomTile(this.newCustomTileResponse.id, this.newCustomTileResponse);
    }
  }

  setIndex(value: number) {
    this.tabIndex = value;
    // if user in profile and going to custom-main-tile tab -> refresh this.selctedContGrpsForProfile
    if (this.presentPage === this.profilePage && this.tabIndex === 1) {
      this.selctedContGrpsForProfile = {
        contentGrps: []
      };
      this.displayHeroTiles.forEach(a => a.showOnDevice = a.addToPackage = false);
    }
    this.cmnService.emitTabIndex(this.tabIndex);
  }

  /* Delete attrat loop content */
  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openDeleteModal(heroTileId: string) {
    this.herTileoToDelete = this.displayHeroTiles.find(ele => ele.id === heroTileId).id;
    this.heroTileToDeleteName = this.displayHeroTiles.find(ele => ele.id === heroTileId).publishedName;
    this.openModal(this.deleteModal);
  }

  deleteHeroTile(heroTileId: string) {
    let deleteServiceCall
    deleteServiceCall = this.heroTileService.deleteHeroTileById(heroTileId);
    if (this.tabActive === this.globalconst.CUSTOM_CONTENT) {
      deleteServiceCall = this.heroTileService.deleteHeroTileById(heroTileId, true);
    }
    deleteServiceCall.pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(deleteResponse => {
        const index = this.displayHeroTiles.findIndex(d => d.id === heroTileId); // find index in your array
        if (index >= 0) {
          this.displayHeroTiles.splice(index, 1); // remove element from array
        }
        if (GlobalConstants.SRT_CONTENT === this.tabActive) {
          this.deleteFilesById(heroTileId, AssetLibraryConstants.HERO_TILE_PATH);
          this.deleteFilesById(heroTileId, AssetLibraryConstants.GAMING_BANNER_PATH);
          this.deleteFilesById(heroTileId, AssetLibraryConstants.FALLBACK_EXE);
        } else {
          this.deleteFilesById(heroTileId, AssetLibraryConstants.MAIN_TILE_IMAGE);
          this.deleteFilesById(heroTileId, AssetLibraryConstants.GAMING_IPOS_BANNER);
        }
        this.closeModal(this.deleteModal);
      },
        error => {
          // do something
          this.closeModal(this.deleteModal);
        });
  }

  deleteFilesById(heroTileId, path) {
    let deleteFileService
    deleteFileService = this.heroTileService.deleteS3HeroTileDataByTileId(heroTileId, path)
    if (GlobalConstants.CUSTOM_CONTENT === this.tabActive) {
      deleteFileService = this.heroTileService.deleteS3HeroTileDataByTileId(heroTileId, path, true)
    }
    deleteFileService.pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(output => { });
  }

  openSendToRetailerModal(heroTileId: string) {
    const tileData = this.displayHeroTiles.find(ele => ele.id === heroTileId);
    this.heroTileToShare = tileData.id;
    this.heroTileToShareName = tileData.retailerName;
    this.heroTileToShareDesc = `This will send ${tileData.publishedName} to all ${tileData.retailerName} stores.`;
    this.heroTileSuccessMsg = `${tileData.publishedName} Tile has been sent`;
    this.heroTileSuccessInfoMsg = `${tileData.retailerName} has received ${tileData.publishedName} Tile`;
    this.openModal(this.sendToRetailerModal);
  }

  sendHeroTileToRetailer(heroTileToShare: string) {
    this.heroTileService.sendHeroTileToRetailer(heroTileToShare)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(sendHeroTileResponse => {
        this.isSuccess = true;
        this.cmnService.emitSendHeroTileStatus(this.isSuccess);
        this.getAllHeroTilesByUser(GlobalConstants.SRT_CONTENT);
      },
        error => {
          this.isSuccess = false;
          this.cmnService.emitSendHeroTileStatus(this.isSuccess);
        });
  }

  loadMiniPreview(gId: string, pageContent: any) {
    this.pageGrpForm = {
      bgcolor: pageContent ? pageContent.bgColor : '#0068B5',
      heading: pageContent ? pageContent.title : '',
      hcolor: pageContent ? pageContent.titleFontColor : '#ffffff',
      body: pageContent ? pageContent.bodyCopy : '',
      bcolor: pageContent ? pageContent.bodyCopyFontColor : '#ffffff',
      size: pageContent ? Utils.getFontSize(pageContent.bodyCopyFontSize) : GlobalConstants.MEDIUM,
      media: {

        url: (pageContent && pageContent.linkedAsset) ?
          environment.apiBaseUrlAsset + this.url + AssetLibraryConstants.SRT_HERO_TILES + AssetLibraryConstants.SLASH + gId + AssetLibraryConstants.SLASH + pageContent.pageNum.toString() : '',
        name: '',
        format: (pageContent && pageContent.linkedAsset) ? (pageContent.linkedAssetFileType) ? pageContent.linkedAssetFileType : '' : '',
        fileObj: ''
      },
      id: gId,    // adding created group id,
      layout: pageContent ? Utils.getUILayoutIDByName(pageContent.UiLayout) : 3,
      fullScreenCheckbox: pageContent ? pageContent?.fullScreenCheckbox ? 
      pageContent.fullScreenCheckbox : false : true
    };
    return this.pageGrpForm;
  }

  setCreatedGrpID(data) {
    if (typeof data === 'object' && data.cancel) {
      this.setIndex(0);
    }
  }

  refreshHeroTiledata(which) {
    this.setIndex(0);
    this.getAllHeroTilesByUser(which);
  }

  getDetailsOfHeroTile(id: string) {
    this.displayHeroTiles.forEach(element => {
      if (element.id === id) {
        element.isExpanded = !element.isExpanded;
        element.previewTabIndex = 0;
        this.singleTileData = element;
      }
    });
  }

  sortByDate() {
    this.page = 1;
    this.sortValue = GlobalConstants.CREATED_DATE;
    this.displayHeroTiles.sort((loop1, loop2) => loop2.updateTime - loop1.updateTime);

  }

  sortByName() {
    this.page = 1;
    this.sortValue = GlobalConstants.GROUP_NAME;
    this.displayHeroTiles.sort((loop1, loop2) =>
      loop1.publishedName.localeCompare(loop2.publishedName));
  }

  createNewHeroTile() {
    this.dataService.setHeroTile(undefined);
    this.tabIndex = 1;
  }
  removeHeroTile() {
    this.sendHeroTileData.emit('None');
    if (this.tabActive === this.globalconst.SRT_CONTENT) {
      this.selectedHeroTileForProfile.contentGrps.push({
        'srtHeroTileId': this.profileDetails.srtHeroTileId,
        'showOnDevice': false,
      });
    } else {
      this.displayHeroTiles.forEach(element => {
        element.isChecked = false;
      });
      this.selctedContGrpsForProfile.showOnDevice = undefined;
      this.selctedContGrpsForProfile.contentGrps.forEach(value => {
        value['showOnDevice'] = false;
      })
      this.cmnService.emitLivePreviewImageData('');
      this.cmnService.emitLivePreviewCTAData('');
    }
  }

  addToProfile(data: any, index: number, eventSource: string) {
    let payload
    let image
    //IIT2-6238 STARTS
    // for radio button selection
    if (this.tabActive === this.globalconst.CUSTOM_CONTENT) {
      if (eventSource === GlobalConstants.RADIO) {
        // if switching show on device one to others
        if (!this.selctedContGrpsForProfile?.showOnDevice && this.displayHeroTiles[index].addToPackage) {
          this.selctedContGrpsForProfile.showOnDevice = this.displayHeroTiles[index].id;
          this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.CUSTOM_HERO_TILE_ID, true);
          this.displayHeroTiles[index].showOnDevice = true;
        } // if show on device not selected.
        else if (this.selctedContGrpsForProfile?.showOnDevice && this.displayHeroTiles[index].addToPackage) {
          this.findIndexAndSetValue(GlobalConstants.DISPLAY_CUSTOM_TILE, GlobalConstants.ID, false);
          this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.CUSTOM_HERO_TILE_ID, false);
          this.displayHeroTiles[index].showOnDevice = true;
          this.selctedContGrpsForProfile.showOnDevice = this.displayHeroTiles[index].id;
          this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.CUSTOM_HERO_TILE_ID, true);
        } else {
          data.target.checked = false;
        }
      }
      // for checkbox  selection
      else if (eventSource === GlobalConstants.CHECK) {
        if (this.selctedContGrpsForProfile?.contentGrps?.length === 1 && (this.selctedContGrpsForProfile?.contentGrps[0]?.customHeroTileId === undefined
          || this.selctedContGrpsForProfile?.contentGrps[0]?.customHeroTileId === "")) {
          this.selctedContGrpsForProfile.contentGrps = [];
        }
        if (data.target.checked) {
          if (this.selctedContGrpsForProfile?.contentGrps?.length <= 2) {
            this.displayHeroTiles[index].addToPackage = data.target.checked;
            this.pushToSelectedGrps(index);
          } else {
            data.target.checked = false;
          }
        } else {
          if (this.displayHeroTiles[index].showOnDevice) {
            this.selctedContGrpsForProfile.showOnDevice = undefined;
          }
          this.setCustomPackageNshowOnDeviceVal(index, false);
          const checkInd = this.selctedContGrpsForProfile?.contentGrps?.findIndex(
            d => d.customHeroTileId === this.displayHeroTiles[index].id);
          if (checkInd >= 0) {
            this.selctedContGrpsForProfile.contentGrps.splice(checkInd, 1);
          }
        }
      }  //IIT2-6238 ENDS
      //data=this.displayHeroTiles[index];
      payload = {
        customHeroTileId: data.id,
        showOnDevice: true
      }
      image = data.heroImageURL;
    }
    else {
      payload = {
        srtHeroTileId: data.id,
        showOnDevice: true
      }
      image = data.heroImageURL;
    }
    this.selectedHeroTileForProfile.contentGrps = [];
    this.selectedHeroTileForProfile.contentGrps.push(payload);
    if ((eventSource === GlobalConstants.RADIO)||(eventSource === 'srt'))
    {this.cmnService.emitLivePreviewImageData(image);}
    this.cmnService.emitLivePreviewCTAData(data.callToAction);
    this.sendHeroTileData.emit(payload);
  }

  sendToProfile(action: string) {
    if (action === GlobalConstants.SKIP) {
      this.cmnService.emitDataToProfile({ page: GlobalConstants.HERO_TILE, dataSet: GlobalConstants.SKIP });
    } else {
      if (this.tabActive === this.globalconst.SRT_CONTENT) {
        this.cmnService.emitDataToProfile({ page: GlobalConstants.HERO_TILE, dataSet: this.selectedHeroTileForProfile.contentGrps });
      }
      if (this.tabActive === this.globalconst.CUSTOM_CONTENT) {
        if (!this.selctedContGrpsForProfile?.contentGrps?.length) {
          this.selctedContGrpsForProfile.contentGrps = [{
            'customHeroTileId': undefined,
            'showOnDevice': true,
          }];
        }
        this.cmnService.emitDataToProfile({ page: GlobalConstants.HERO_TILE, dataSet: this.selctedContGrpsForProfile.contentGrps });
      }
    }
    this.cmnService.scrollTopInitial();
  }

  fetchImagesForHeroTile(promoCGId: string, pageNum: string) {
    const reader = new FileReader();

    this.heroTileService.getHeroTileDataByTileId(promoCGId, pageNum)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(imageData => {
        reader.addEventListener('load', () => {
          this.pageGrpForm.media.url = reader.result;
          this.pageGrpForm.media.name = 'name';
          this.pageGrpForm.media.format = 'image'; // TODO
          // this.emitPageDataToPreview();
        }, false);

        if (imageData) {
          reader.readAsDataURL(imageData);
        }
      },
        error => {
          // do something
        });
  }
  setCTAValue(ctatext) {
    this.sendctavalue = ctatext;
  }
  tabChange(data) {
    if (data == GlobalConstants.CUSTOM_CONTENT) {
      this.isCustomContentTabActive = true;
      this.isSrtTabActive = false;
      this.tabActive = GlobalConstants.CUSTOM_CONTENT;
      this.getAllHeroTilesByUser(data);
    } else if (data == GlobalConstants.SRT_CONTENT) {
      this.isSrtTabActive = true;
      this.isCustomContentTabActive = false;
      this.tabActive = GlobalConstants.SRT_CONTENT;
      this.getAllHeroTilesByUser(data);
    }
    this.cmnService.setHeroTab(this.tabActive);
  }
  newCustomMainTile() {
    this.sendEditData = null;
    this.tabIndex = 3;
    this.isDuplicateEnabled = false;
  }
  previewNavigate(ind, id) {
    this.displayHeroTiles.forEach(element => {
      if (element.id === id) {
        element.previewTabIndex = ind;
        this.previewTabIndex = ind;
      }
    });
  }

  //Passing Navigation Click to child element (mini-live-preview)
  animateTiles(data) {
    this.cmnService.passNavBtnClicks(data);
    this.clickedRight = data;
  }

  //IIT2-6238 STARTS
  //For deselecting if limit reached
  setCustomPackageNshowOnDeviceVal(index: number, value: boolean) {
    this.displayHeroTiles[index].showOnDevice = this.displayHeroTiles[index].addToPackage = value;
  }
  // for AddToProfile
  findIndexAndSetValue(setValueTo: string, keyName: string, setValueAs: any) {
    if (setValueTo === GlobalConstants.DISPLAY_CUSTOM_TILE) {
      const checkInd = this.displayHeroTiles.findIndex(d => d[keyName] === this.selctedContGrpsForProfile.showOnDevice);
      this.displayHeroTiles[checkInd].showOnDevice = setValueAs;
    } else {
      const checkIndContentGrps = this.selctedContGrpsForProfile?.contentGrps?.findIndex(
        d => d[keyName] === this.selctedContGrpsForProfile.showOnDevice);
      this.selctedContGrpsForProfile.contentGrps[checkIndContentGrps].showOnDevice = setValueAs;
    }
  }

  // Adding content group objects for profile
  pushToSelectedGrps(ind: number) {
    this.selctedContGrpsForProfile.contentGrps.push({
      'customHeroTileId': this.displayHeroTiles[ind].id,
      'showOnDevice': this.displayHeroTiles[ind].showOnDevice,
    });
  }

  showOnDeviceTile(data) {
    this.showDevice = data;
    this.redirectToList();
  }

  redirectToList() {
    this.setIndex(0);
    this.getAllHeroTilesByUser(GlobalConstants.CUSTOM_CONTENT);
  }

  closeCustomDevice(data) {
    if (data) {
      this.showDevice = false;
      this.selctedContGrpsForProfile.contentGrps = [];
      this.selctedContGrpsForProfile.showOnDevice = false;
      this.redirectToList();
    }
  }
  //IIT2-6238 ends
}
